import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="footer" className="relative py-12 border-t border-slate-200">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <img
            src="https://customer-assets.emergentagent.com/job_1488b547-0470-4710-9082-0fb679cd81f3/artifacts/0ckydwjt_Orange%20kidney%20%281%29.jpg"
            alt="KidneyCheQ"
            className="h-10 w-10 object-contain"
          />
          <span className="font-display text-xl font-bold text-slate-800">
            KidneyCheQ
          </span>
        </div>

        <div className="flex items-center gap-6 text-slate-600 text-sm">
          <a href="#product" className="hover:text-slate-800 transition-colors">Product</a>
          <a href="#team" className="hover:text-slate-800 transition-colors">Team</a>
          <a href="#contact" className="hover:text-slate-800 transition-colors">Contact</a>
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-slate-800 transition-colors">Privacy Policy</Link>
        </div>

        <div className="text-slate-500 text-sm">
          © 2026 Ominar Innovations Pvt Ltd. All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
);
